import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { refreshSession } from './features/auth/auth-api';
import { createQueryClient } from './lib/query-client';
import { routeTree } from './routeTree.gen';
import './index.css';

const queryClient = createQueryClient({
  // An API call in the signed-in area failed with 401/403-setup: re-check the session, the
  // _app route guard then redirects to the login or TOTP setup.
  onSessionError: () => {
    if (!router.state.matches.some((match) => match.routeId === '/_app')) return;
    void refreshSession(queryClient).then(() => router.invalidate());
  },
});

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  // Loaders read from TanStack Query, which handles caching.
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');
if (rootElement === null) throw new Error('#root element missing');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
